export default "__VITE_ASSET__81VT8jKc__"